import React from "react"
import heroStyles from "./hero.module.scss"
import { useStaticQuery, graphql } from "gatsby"

export default function Hero() {
  const data = useStaticQuery(graphql`
    query airtableHero {
      allAirtable(
        sort: { fields: data___order, order: ASC }
        filter: { data: { section: { eq: "hero" } } }
      ) {
        edges {
          node {
            id
            data {
              text
              section
              description
              order
              text2
              image {
                url
                filename
                type
              }
            }
          }
        }
      }
    }
  `)

  const background = data.allAirtable.edges[0].node.data.image[0].url

  return (
    <div
      className={heroStyles.heroContainer}
      style={{
        backgroundImage: `linear-gradient(rgba(15, 127, 255, 0.69) 100%, rgba(15, 127, 255, 0.69) 100%), url(${background})`,
      }}
    >
      {data.allAirtable.edges.map(edge => {
        return (
          <h1 key={edge.node.id} className={heroStyles.heroText}>
            <span className={heroStyles.titleOne}>{edge.node.data.text}</span>
            <br />
            <span className={heroStyles.titleTwo}>
              {edge.node.data.description}
            </span>
          </h1>
        )
      })}
    </div>
  )
}
